export const SPACE = {
    size: '5rem',
    border: '1px solid #8B4513',
  };
